module.exports = "pegasus/assets/themelp1/small/53.png";